import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import Select from 'react-select'
import update from 'immutability-helper'

import Icon from 'Pods/Shared/Icon/Icon'
import TextareaField from 'Pods/Shared/TextareaField'

class ReportConversationModal extends React.Component {
  constructor() {
    super()

    this.state = this.getInitialState()

    this.onSortChange = this.onSortChange.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.onModalClose = this.onModalClose.bind(this)
    this.handleFormSubmit = this.handleFormSubmit.bind(this)
    this.onSubmitSuccess = this.onSubmitSuccess.bind(this)
    this.onSubmitFailure = this.onSubmitFailure.bind(this)
  }

  getInitialState() {
    return {
      reason: '',
      reasonValue: '',
      comment: '',
      showError: false,
    }
  }

  onModalClose() {
    this.setState(this.getInitialState())
    this.props.closeModal()
  }

  onSortChange(data) {
    this.setState({
      reason: data.label,
      reasonValue: data.value,
      showError: data.label.length === 0,
    })
  }

  handleInputChange(e) {
    const newState = update(this.state, { [e.target.id]: { $set: e.target.value } })

    this.setState(newState)
  }

  handleFormSubmit(e) {
    e.preventDefault()

    if (this.state.reason.length === 0) {
      this.setState({ showError: true })
    } else {
      axios.put('/api/internal/users/report-conversation', {
        conversation_id: this.props.conversationId,
        username: this.props.recipient,
        reason: this.state.reasonValue,
        comment: this.state.comment,
      })
        .then(this.onSubmitSuccess)
        .catch(this.onSubmitFailure)
    }
  }

  onSubmitFailure() {
    App.events.publish('app:notification:flash:error', 'Unfortunately message couldn\'t be reported.')
  }

  onSubmitSuccess() {
    App.events.publish('app:notification:flash:success', 'Conversation was reported.')

    window.customEventTracker({
      name: 'report_content',
      userId: App.config.userId || '',
      eventData: {
        content_type: 'conversation',
        report_reason: this.state.reason,
      }
    })

    this.props.onReportSuccess()
    this.props.closeModal()
  }

  render() {
    const reasonOptions = [
      { value: 'spam', label: 'Spam' },
      { value: 'language', label: 'Abusive Language' },
      { value: 'scam', label: 'Scam' },
      { value: 'other', label: 'Other' },
    ]

    return (
      <Modal
        isOpen={this.props.modalIsOpen}
        shouldCloseOnOverlayClick
        onRequestClose={this.onModalClose}
        contentLabel="Modal"
        ariaHideApp={false}
        className={{
          base: '',
          afterOpen: 'overlay-modal--container_after-open overlay-modal-container--smaller',
          beforeClose: 'overlay-modal--container_before-close',
        }}
        overlayClassName={{
          base: 'overlay-modal--background',
          afterOpen: 'overlay-modal--background_after-open',
          beforeClose: 'overlay-modal--background_before-close',
        }}
      >
        <div className="overlay-modal">
          <button className="btn btn-transparent overlay-modal--close-inner" onClick={this.onModalClose}>
            <Icon type={['fal', 'times']} color="grey-dark" />
          </button>
          <div className="overlay-modal--content overlay-modal--report-conversation">
            <div className="l-inner-large">
              <div className="header">Report spam or abuse</div>
              <form onSubmit={(e) => this.handleFormSubmit(e)}>
                <label>Reason <strong>*</strong></label>
                <Select
                  className="Select-new"
                  id="reason"
                  placeholder="Select reporting reason"
                  options={reasonOptions}
                  onChange={this.onSortChange}
                  value={this.state.reasonValue}
                  searchable={false}
                  clearable={false}
                />
                {this.state.showError && <div className="text-warning u-mb10"><small>Please select reporting reason.</small></div>}
                <TextareaField
                  label="Comment"
                  id="comment"
                  name="comment"
                  value={this.state.comment}
                  inputClassName="form-control-lg field--important"
                  onChange={this.handleInputChange}
                />
                <div className="footer u-text-center">
                  <button type="submit" className="btn btn-fat btn-primary u-mr10">Submit</button>
                  <button className="btn btn-fat btn-outline-primary" onClick={this.onModalClose}>Close</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

ReportConversationModal.propTypes = {
  modalIsOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  onReportSuccess: PropTypes.func.isRequired,
  recipient: PropTypes.string.isRequired,
  conversationId: PropTypes.string.isRequired,
}

export default ReportConversationModal
